import { TRPCClientErrorLike } from '@trpc/client';
import { TRPCError } from '@trpc/server';

export const serverError = (e: TRPCClientErrorLike<any> | Error) => {
  console.error(e);
  // Lazy-load so server modules that only need CustomTRPCError don't evaluate
  // the Sonner client toast helper during `next build` page-data collection.
  void import('~/utils/toast').then(({ toast }) => {
    toast.error(e.message);
  });
};

/**
 * Returns readable message to be thrown from server for user
 * @param action
 * @returns
 */
export const transformErrorMessage = (action: string) => {
  return `There was an error in ${action}. Please share this error message or a screenshot with your support team over Slack or founders@tryprotege.com.`;
};

/**
 * Custom error to be thrown from trpc endpoints
 *
 *
 * */
export class CustomTRPCError extends TRPCError {
  public meta: object | undefined;
  public userFriendlyMsg: string | undefined;
  /** Default to `true` because this is mostly used for input validation */
  public isWarning = true;

  constructor(
    opts: ConstructorParameters<typeof TRPCError>[0] & {
      /** Additional metadata for the error */
      meta?: object;
      /** Log the error as a warning */
      isWarning?: boolean;
      /** User friendly message for the error */
      userFriendlyMsg?: string;
    },
  ) {
    super({
      message: opts.message || opts.userFriendlyMsg,
      code: opts.code,
      cause: opts.cause,
    });
    this.meta = opts.meta;
    this.userFriendlyMsg = opts.userFriendlyMsg;

    if (typeof opts.isWarning === 'boolean') {
      this.isWarning = opts.isWarning;
    }
  }
}
